// extracted by mini-css-extract-plugin
export default {"qTalkBreadcrumbs":"IndividualQtalk_qTalkBreadcrumbs__oF97D"};